import React from 'react';
import { Box, Center, Flex, Image, SimpleGrid } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import piggybankImg from '../../../assets/images/piggybank.svg';
import { DateRangeType } from '../../../common/components/DateRangeTypePicker';
import { SEHomeCard } from '../../../common/components/SEHomeCard';
import { getDateRangeTypeSufix } from '../../../utils/common/common-utils';

type Props = {
  readonly totalCost: string;
  readonly dateRangeType: DateRangeType;
};

export function ChargingTotalCostCard({ totalCost, dateRangeType }: Props) {
  const { t } = useTranslation();

  return (
    <SimpleGrid gap={3} columns={1} mt={4} w="100%">
      <SEHomeCard p={4} borderTopLeftRadius={5} data-testid="total-cost-card">
        <Flex>
          <Center w="30%">
            <Image w={'75%'} my={4} src={piggybankImg} />
          </Center>
          <Center flexDirection="column">
            <Box ml={2}>
              <Box fontWeight={'normal'} fontSize={'sm'} textTransform="uppercase" data-testid="total-cost-msg">
                {t('Activity.total cost')}
                {` ${getDateRangeTypeSufix(dateRangeType)}`}
              </Box>
              <Box as={'span'} fontSize={'3xl'} fontWeight={'bold'} data-testid="total-cost-value">
                {`$${totalCost}`}
              </Box>
            </Box>
          </Center>
        </Flex>
      </SEHomeCard>
    </SimpleGrid>
  );
}
